import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FontEnum } from "../../../../SharedComponents/utils/enums/FontEnum";
import NotificationsTableRow from "../TableRows/NotificationsTableRow";
import { getOldNotifications } from "../../../reduxStore/entities/notifications";

const PreviousNotificationsTable = () => {
    const dispatch = useDispatch();

    const [loaded, setLoaded] = useState(false);

    const fetchedOldNotifications = useSelector((state) => state.notifications.oldNotifications);


    useEffect(() => {
        setLoaded(true);
    }, [fetchedOldNotifications]);

    useEffect(() => {
        dispatch(getOldNotifications());
    }, []);

    if (!loaded) {
        return null;
    };

    return (
        <div style={styles.mainContainer}>
            <p style={styles.title}>
                {"Prethodna obaveštenja"}
            </p>

            <div style={styles.notificationComponent}>
                {fetchedOldNotifications.map((notification, index) => {
                    return (
                        <NotificationsTableRow
                            key={index}
                            notification={notification}
                        />
                    );
                })}
            </div>

        </div>
    );
};

export default PreviousNotificationsTable;

const styles = {
    mainContainer: {
        width: "33%"
    },
    title: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 600,
        fontSize: "24px",
        color: "rgba(0, 0, 0, 0.87)"
    },
    notificationComponent: {
        marginTop: 25
    }
};